import React from "react";
import { Navigate, Outlet } from "react-router-dom";
// redux
import Spinner from "../util/Spinner";
// hooks
import { useAuthStatus } from "../../hooks/useAuthStatus";

const ProtectedRoute = ({ children }) => {
  const { loggedIn, checkingStatus } = useAuthStatus();

  const adminPortalLogin = process.env.REACT_APP_ADMIN_PORTAL;

  const navigateToLoginPortal = () => {
    window.location.href = adminPortalLogin;
  };

  if (checkingStatus) {
    return <Spinner />;
  }

  //   Outlet used so the routes can load the child
  return loggedIn && !checkingStatus ? <Outlet /> : navigateToLoginPortal();
};

export default ProtectedRoute;
